/**
 * Centralised E-E-A-T / reviewer schema constants.
 * Import these wherever you need the reviewedBy JSON-LD object
 * so every page stays in sync.
 */

export const SITE_URL = "https://contraceptiondirect.uk";

export const REVIEWER_SCHEMA = {
  "@type": "Person" as const,
  "name": "Usama Ali",
  "jobTitle": "Co-founder and Pharmacist",
  "hasCredential": {
    "@type": "EducationalOccupationalCredential" as const,
    "credentialCategory": "degree",
    "educationalLevel": "Master of Pharmacy",
    "name": "MPharm",
  },
  "identifier": {
    "@type": "PropertyValue" as const,
    "propertyID": "GPhC Registration Number",
    "value": "2224726",
  },
  "@id": `${SITE_URL}/authors/usama-ali#person`,
  "url": `${SITE_URL}/authors/usama-ali`,
  "worksFor": { "@id": `${SITE_URL}/#organization` },
};

export const ABOUT_CONTRACEPTION_SCHEMA = {
  "@type": "MedicalCondition" as const,
  "name": "Contraception",
  "associatedAnatomy": { "@type": "AnatomicalSystem" as const, "name": "Reproductive system" },
};

export const WEBSITE_SCHEMA = {
  "@type": "WebSite" as const,
  "@id": `${SITE_URL}/#website`,
  "url": `${SITE_URL}/`,
  "name": "Contraception Direct",
  "publisher": { "@id": `${SITE_URL}/#organization` },
};

export const PUBLISHER_SCHEMA = {
  "@type": "Organization" as const,
  "name": "Contraception Direct",
  "url": SITE_URL,
};
